module.exports = __webpack_public_path__ + "static/media/ic_clear.4b843ec2.svg";